import { customField } from "@/components/custom-field/type";
import { BaseMaintenanceViewPage } from "./view";
import {
  alertSuccess,
  alertError,
  alertDelete,
} from "@cems-eco/core/src/utils/widget";
import { ElLoading } from "element-plus";

export class CloudMaintenanceViewPage extends BaseMaintenanceViewPage {
  async mounted() {
    const loader = ElLoading.service({ lock: true });

    this.maintenance.id = this.$route.params.id;
    this.maintenance = await this.maintenanceBloc.getMaintenance(
      this.maintenance.id
    );
    this.maintenance.custom_field =
      this.maintenance.custom_field ?? customField();
    this.updateDatetimeInput();

    loader.close();
  }

  async remove() {
    alertDelete().then(async (result) => {
      try {
        if (!result.isConfirmed) {
          alertSuccess("Deletion abort.", "Your data is save.");
          return;
        }
        let message = await this.maintenanceBloc.destroyMaintenance(
          this.maintenance.id
        );
        alertSuccess("Good Job!", "Your data has been deleted.");
        this.$router.replace("/maintenance");
      } catch (error) {
        alertError(error);
      }
    });
  }
}
